import { PagenatedQuery, PagenatedResponse } from '@models/common';
import { Notice } from '@models/notice';
import { apiClient } from '.';

export const searchNotices = async (query: PagenatedQuery) => {
  return apiClient.get<PagenatedResponse<Notice>>(`/admin/v1/notices`, {
    params: query,
  });
};
